import React, { useState } from "react";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

export default function AppLayout({ children, searchPlaceholder }) {
    const [navOpen, setNavOpen] = useState(false);
    return (
        <div className="min-h-screen bg-ink-900 flex text-white">
            <Sidebar navOpen={navOpen} onNavClose={() => setNavOpen(false)} />
            <div className="flex-1 min-w-0 flex flex-col">
                <Topbar searchPlaceholder={searchPlaceholder} onMenuOpen={() => setNavOpen(true)} />
                <main className="flex-1 p-4 lg:p-10">{children}</main>
            </div>
        </div>
    );
}
